import { ActionIcon } from '@mantine/core';
import { IconEyeOff, IconEyeCheck, IconArrowBackUp, IconBallpen } from '@tabler/icons';
import { FC, useContext } from 'react';
import { useParams } from 'react-router-dom';
import BookitupThemeIcon from '../../Atoms/BookitupThemeIcon';
import { EmailBoxContext } from '../../Service/Context/EmailBoxContext';
import { MessageS } from '../../Service/MessageS';

interface Props {
  phoneVersion: boolean;
}

const EmailActions: FC<Props> = ({ phoneVersion }) => {
  const { box } = useParams();
  const { selectedMessage, selectMessage, prepareMessage, changeEmail } = useContext(EmailBoxContext);

  if (!selectedMessage) return null;

  const markAsReadHandler = async (read: boolean) => {
    if (selectedMessage) {
      const patchedEmail = await MessageS.patchEmail(selectedMessage.id, { read });
      if (patchedEmail) {
        changeEmail(patchedEmail);
        selectMessage(patchedEmail);
      }
    }
  };

  return (
    <>
      {selectedMessage.readTimestamp && phoneVersion && box === 'inbox' && (
        <ActionIcon onClick={() => markAsReadHandler(false)}>
          <IconEyeOff size={20} />
        </ActionIcon>
      )}
      {!selectedMessage.readTimestamp && phoneVersion && box === 'inbox' && (
        <ActionIcon onClick={() => markAsReadHandler(true)}>
          <IconEyeCheck size={20} />
        </ActionIcon>
      )}
      {phoneVersion && box === 'inbox' && (
        <BookitupThemeIcon size={28} onClick={() => prepareMessage('REPLY')}>
          <IconArrowBackUp size={20} />
        </BookitupThemeIcon>
      )}
      {phoneVersion && box === 'drafts' && (
        <BookitupThemeIcon size={28} onClick={() => prepareMessage('EDIT')}>
          <IconBallpen size={20} />
        </BookitupThemeIcon>
      )}
    </>
  );
};

export default EmailActions;
